import { useEffect, useRef, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { ANSWER } from '../../../constants/website.constant';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import useLogEventInAnalytics from '../../../hooks/useLogAnalyticsEvent';
import * as AuthService from '../../../services/users/signup.service';
import { getContentForDialog } from '../Landing/constants';

const unregisteredUserStatus = ['waiting', 'processing'];

export const useRegister = () => {
  const ref = useRef(0);
  const isLoading = useRef(false);
  const { onLogin } = useAuthDataContext();
  const requestData = useRef(null);

  const {
    isError: registerUserIsError,
    error: registerUserError,
    mutate: registerUserMutate,
  } = useMutation(async (values: any) => {
    const user = {
      ...values,
      phone: `${values.cod}${values.phone_number}`,
    };
    if (!values.patentsInsured && process.env.REACT_APP_WEBSITE === ANSWER) {
      delete user.license_plate;
      delete user.patentsInsured;
    } else {
      delete user.patentsInsured;
    }
    return await AuthService.signUp({
      user,
    });
  });

  const checkSignUpStatus = useMutation(
    async (data: any) => {
      return await AuthService.checkSignUpStatus(data);
    },
    {
      onSuccess: (response, url) => {
        if (
          !unregisteredUserStatus.includes(response.data?.status) &&
          response?.status != 202
        ) {
          isLoading.current = false;
          // TODO: review this
          if (
            response.data.status == 'processed' &&
            (response.data.response?.status_code == 201 ||
              response.data.response?.status_code == 200)
          ) {
            if (JSON.parse(response.data.response.body) !== null) {
              localStorage.setItem('user', response.data.response.body);
              const parsedResponse = JSON.parse(response.data.response.body);
              onLogin(parsedResponse);
            } else {
              throw new EvalError('try_manually_login');
            }
          } else {
            throw new EvalError('register_failure');
          }
        } else {
          ref.current += 1;
          if (ref.current <= 60) {
            setTimeout(() => {
              checkSignUpStatus.mutate(requestData.current);
            }, 5000);
          } else {
            isLoading.current = false;
            throw new EvalError('register_failure');
          }
        }
      },
      onError: () => {
        isLoading.current = false;
      },
    }
  );

  const handleSubmit = async (values: any, form: any) => {
    isLoading.current = true;
    registerUserMutate(values, {
      onSuccess: (data: any) => {
        requestData.current = data;
        checkSignUpStatus.mutate(data);
      },
      onError: (error: any) => {
        isLoading.current = false;
        // console.info(error);
        // console.info(error?.response?.data);
        form.reset(values);
      },
    });
  };

  return {
    isLoading: isLoading.current,
    error: registerUserError || checkSignUpStatus.error,
    isError: registerUserIsError || checkSignUpStatus.isError,
    handleSubmit,
  };
};

export const useErrorHandling = (isError, error) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const { logEvent } = useLogEventInAnalytics();

  useEffect(() => {
    if (isError) {
      setOpen(true);
    }
  }, [isError]);

  const handleClose = () => {
    setOpen(false);
  };

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  return {
    open,
    handleClose,
    dialog: getContentForDialog(
      error?.response?.data?.errors != 'Email Email ya en uso!' &&
        error instanceof EvalError
        ? error?.message
        : error?.response?.data?.errors,
      error?.message === 'try_manually_login'
        ? () => redirectHome()
        : handleClose,
      logEvent
    ),
  };
};
